import { render, staticRenderFns } from "./MyAlert.vue?vue&type=template&id=8e8141e2&"
import script from "./MyAlert.vue?vue&type=script&lang=js&"
export * from "./MyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports